import { render, staticRenderFns } from "./FontEdit.vue?vue&type=template&id=4fa4ff22&scoped=true&"
import script from "./FontEdit.vue?vue&type=script&lang=js&"
export * from "./FontEdit.vue?vue&type=script&lang=js&"
import style0 from "./FontEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FontEdit.vue?vue&type=style&index=1&id=4fa4ff22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4ff22",
  null
  
)

export default component.exports